

































































import { Vue, Component } from "vue-property-decorator"
import Section from "@/components/BaseComponents/Section.vue"

const AppProps = Vue.extend({
	props: {}
})

@Component({
	components: {
		Section
	}
})
export default class Home extends AppProps {
	frontImages: CarouselObject[] = [
		{
			caption: "Jordbærtærte",
			src: "@/assets/carousel/jordbaertaerte.jpg"
		},
		{
			caption: "Lemon meringue pie",
			src: "@/assets/carousel/front.jpg"
		},
		{
			caption: "Kanelsnurrer",
			src: "@/assets/carousel/kanelsnurrer.png"
		}
	];

	welcomeTextList: string[] = [
		"Velkommen til!",
		"På denne side findes der et bredt udvalg af de opskrifter, som jeg benytter meget i hverdagen og som jeg synes er så gode, at de burde deles med verden -- eller hvertfald Danmark.",
		"Min idé med disse opskrifter er at give en kort og præcis beskrivelse af ingredienser og fremgangsmåder samt at undgå for meget sniksnak og lange beskrivende tekster (bortset fra denne).",
		"Alle opskrifter kan ganges op i størrelse og jeg udvider løbende siden med ny funktionalitet. Sammen med opskrifterne er der også en enhedsoversætter, så du nemt kan oversætte enheder fra en måleenhed til en anden.",
		"Nogle opskrifter er stærkt inspireret af opskrifter jeg har fundet på nettet. Her har jeg linket til originalen i den pågældende opskrift. Disse opskrifter har jeg som oftest forfinet lidt/ændret lidt i mængder eller ingredienser fra originalen.",
		"Jeg håber du finder noget du kan lide!",
		"Jeg er hverken fotograf, eller designer, men jeg er softwareingeniør. Billederne du finder her har jeg selv taget og design og udvikling af denne side er mit hobbyprojekt. Skulle du opleve fejl eller mangler på siden, at noget der ikke er beskrevet godt nok, eller har du nogle gode idéer til hvordan siden kunne gøres bedre, er du mere end velkommen til at kontakte mig på en af medierne angivet nedenunder."
	];
}
